import React, { Component } from 'react'


import { GetFiliaisDetails } from '../../../../services';
import swal from 'sweetalert';
import Moment from 'moment';

import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { NotificationManager } from 'react-notifications';

import {
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableCaption,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CButton,
    CSpinner
  } from '@coreui/react'


  import CIcon from '@coreui/icons-react'
  import {
    cilPencil,cilTrash,
  } from '@coreui/icons'

export default class List extends Component {

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
  };

    constructor(props) {
        super(props);
        this.state = {
            getList: [],isLoaded:false,
            filters: {
              name: "",
              leaderOfCell: "",
              cargo: "",
              distrito: "",
              area: "",
              setor: "",
            },
        }
    }
   
   async componentDidMount() {
      this.getFiliais();
    }    

        

    async getFiliais() {
        this.setState({ isLoaded: true })
        let list = await GetFiliaisDetails.FilialList();      
        if (list) {        
        this.setState({ getList: list.data })      
          
        }

        this.setState({ isLoaded: false })
    }


    async handlDeleteById(id,cargo) {
        swal({
            title: "Excluir a Filial " + cargo + " ?",     
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then(async (success) => {
                if (success) {
                    this.setState({ isLoaded: true })
                    let value = await GetFiliaisDetails.FilialDelete(id);
                    if (value) {
                      NotificationManager.success("Create successfull", 'Message'); 
                      this.getUser();
                    }
                    this.setState({ isLoaded: false })
                }
            });
    }

    
    handlEditRow(row,nome,depositante,cd_estabelecimento,cnpj) {      
      this.props.history.push({ pathname: `/admin/filiais/edit/${row}`,state: row,nome:nome,depositante:depositante,
                                                              cd_estabelecimento:cd_estabelecimento,cnpj:cnpj })
    }


    render() {        
        let self = this.state.getList
        let isLoaded = this.state.isLoaded

        const { filters } = this.state;
        const headerStyles = { display: "flex", justifyContent: "space-between" };
        const filterStyles = { display: "flex", alignItems: "center" };
        


        return (
            
          <CRow>          
          <CCol xs={12}>
          <CCard className="mb-4" >
            <CCardHeader style={headerStyles} >           
                 Consulta Filiais
            </CCardHeader>
          <CCardBody>
         
               <CTable align="middle" className="mb-0 border card-body-table table" hover responsive small bordered style={{fontFamily: "Arial"}}>
                <CTableHead color="dark" >
                  <CTableRow color="dark">                   
                    <CTableHeaderCell >Nome</CTableHeaderCell>
                    <CTableHeaderCell >Depositante</CTableHeaderCell> 
                    <CTableHeaderCell >Estabelecimento</CTableHeaderCell>     
                    <CTableHeaderCell >CNPJ</CTableHeaderCell>                    
                    <CTableHeaderCell className="text-center">Alterar</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Deletar</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {self.map((item, index) => (
                    <CTableRow v-for="item in tableItems" key={index} color="success" style={{color: "green"}}>                     
                      <CTableDataCell >{item.nome}</CTableDataCell>                      
                      <CTableDataCell>{item.depositante}</CTableDataCell>                       
                      <CTableDataCell>{item.cd_estabelecimento}</CTableDataCell>    
                      <CTableDataCell>{item.cnpj}</CTableDataCell>                      
                      <CTableDataCell className="text-center" onClick={(e) => this.handlEditRow(item,
                                                                                                item.nome || null,
                                                                                                item.cd_estabelecimento || null,                                                                                         
                                                                                                item.cnpj || null,                                                                                                
                                                                                                )}>                        
                      <CIcon  icon={cilPencil} title='Alterar'/>
                      </CTableDataCell>
                      <CTableDataCell className="text-center">                        
                      <CIcon icon={cilTrash} title='Deletar' onClick={(e) => this.handlDeleteById(item.id,item.nome)}/> 
                      </CTableDataCell>
                    </CTableRow>
                  ))}

                      
                  
                </CTableBody>               
              </CTable>
               <CRow>
              </CRow>
              
              <CButton style={{ flexDirection: 'row', marginTop: 10 }} color="success" width={80} onClick={(e) => this.props.history.push({ pathname: `/admin/filiais/create`})}> Nova Filial</CButton>                          
              
              </CCardBody>
            </CCard> 
            {
                isLoaded ? <CSpinner color="success" style={{ flexDirection: 'row', marginLeft: '50%',alignItems:"center" }}  /> : ''
            }
            
            </CCol >
            
            </CRow>

        )
    }
}
